import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  fontWeight: 500,
  // padding: "8px 24px 8px 24px",
  lineHeight: "22px",
  color: "#FFFFFF",
  backgroundColor: "#7787F7",
  "&:hover": {
    backgroundColor: "#7787F7",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#7787F7",
  },
  "&:focus": {
    boxShadow: "none",
  },

  outline: "none",
  minWidth: "125px",
  width: " max-content",
  padding: "10px",
  borderRadius: " 5px !important",
});

export default BootstrapButton;
